import {Box, Button, Stack, Typography} from "@mui/material";
import CurrencyFormatter from "../../../../components/CurrencyFormatter/CurrencyFormatter";
import {useLocation} from "react-router-dom";
import React from "react";
import {useQuery} from "@apollo/client";
import {GET_USER} from "../../../../store/queries/GetUser";
import {CustomLink} from "../../../../components/CustomLink/CustomLink";
import {useTranslation} from "react-i18next";
import {red} from "@mui/material/colors";
import {AccountStatus} from "../../../../utils/accountStatus";
import {
    GetUserQuery,
    GetUserRegulatorRegistrationQuery,
    PermissionGrade,
    PlayerState,
    User,
    UserRegulatorRegistration
} from "../../../../gql/graphql";
import {GET_USER_REGULATOR_REGISTRATION} from "../../../../store/queries/GetUserRegulatorRegistration";

interface UserDetailsProps {
    isMobile?: boolean;
    backgroundColor?: string;
    color?: string;
    hideDeposit?: boolean;
    hideName?: boolean;
}

export const UserDetails = ({
                                isMobile = false,
                                backgroundColor,
                                color,
                                hideDeposit = false,
                                hideName = false
                            }: UserDetailsProps) => {
    let location = useLocation();
    const {t} = useTranslation();
    const {loading, error, data} = useQuery<GetUserQuery>(GET_USER,
        {
            fetchPolicy: "network-only",
            notifyOnNetworkStatusChange: true
        });
    const getUserRegulatorRegistration = useQuery<GetUserRegulatorRegistrationQuery>(GET_USER_REGULATOR_REGISTRATION,
        {
            fetchPolicy: "network-only",
            notifyOnNetworkStatusChange: true
        });
    const userRegulatorRegistration = getUserRegulatorRegistration.data?.userRegulatorRegistration as UserRegulatorRegistration;
    let state = location.state as { backgroundLocation?: Location };

    return (<Box sx={{
        background: backgroundColor ?? '#f5f5f5',
        px: isMobile ? 3 : 4,
        py: isMobile ? 2 : 4,
        width: isMobile ? '100%' : 400
    }}>
        {(loading || error || data?.identity === null) ? (<></>) : (
            <>
                {!hideName && (
                    <Stack spacing={isMobile ? 0 : 1} direction={isMobile ? 'column' : 'row'}>
                        <Typography variant={isMobile ? 'body2' : 'body1'} sx={{fontWeight: 600}}>
                            {(data?.identity as User).firstName} {(data?.identity as User).lastName}
                        </Typography>
                        <Typography
                            variant={isMobile ? 'body2' : 'body1'}>({(data?.identity as User).userName})</Typography>
                    </Stack>
                )}
                <Stack spacing={1} direction={'row'}>
                    <Typography variant={'body2'}>{t('accountStatus')}:</Typography>
                    <div>
                        <AccountStatus status={(data?.identity as User).status}/>
                        {userRegulatorRegistration?.permissionGrade === PermissionGrade.NotAllowedToPlay && (!userRegulatorRegistration?.playerState || userRegulatorRegistration?.playerState === PlayerState.Hit) && (
                            <Typography sx={{color: red["700"]}} variant={'body2'}>(EPIS hit)</Typography>
                        )}
                        {userRegulatorRegistration?.playerState && [PlayerState.MinorError, PlayerState.MajorError].includes(userRegulatorRegistration?.playerState) && (
                            <Typography sx={{color: red["700"]}}
                                        variant={'body2'}>({t('wrongPersonalDetails')})</Typography>
                        )} 
                    </div>
                </Stack>
                <Stack sx={{mt: isMobile ? 1 : 3}} justifyContent={'space-between'} direction={'row'}
                       alignItems={'center'}>
                    <Stack direction={'column'}>
                        <Typography variant={isMobile ? 'body2' : 'body1'}>{t('balance')}:</Typography>
                        <Typography variant={'body1'} sx={{fontWeight: 600}}><CurrencyFormatter
                            currency={(data?.identity as User).wallet.currency ?? "EUR"}
                            quantity={(data?.identity as User).wallet.balance}/></Typography>
                    </Stack>
                        <Button component={CustomLink} to="/deposit"
                                variant="contained"
                                sx={{borderRadius: 8, height: '32px'}}>{t('deposit')}</Button>
                </Stack>
            </>
        )}

    </Box>);
}
